import React from "react";
import { Globe } from "lucide-react";
import {
  CONSTRAINT_CONNECT_BODY1_MARKER_COLOR,
  CONSTRAINT_CONNECT_BODY2_MARKER_COLOR,
} from "../../viewer/scene/sceneConstants";

const colorNumberToCss = (color) => `#${color.toString(16).padStart(6, "0")}`;

const BODY1_MARKER_COLOR = colorNumberToCss(CONSTRAINT_CONNECT_BODY1_MARKER_COLOR);
const BODY2_MARKER_COLOR = colorNumberToCss(CONSTRAINT_CONNECT_BODY2_MARKER_COLOR);

const ConstraintEndpointMarker = ({ variant = "solid", className = "" }) => {
  if (variant === "wire") {
    return (
      <Globe
        className={`h-4 w-4 shrink-0 ${className}`}
        style={{ color: BODY2_MARKER_COLOR }}
        aria-hidden="true"
      />
    );
  }

  return (
    <span
      className={`inline-flex h-3 w-3 shrink-0 rounded-full ${className}`}
      style={{ backgroundColor: BODY1_MARKER_COLOR }}
      aria-hidden="true"
    />
  );
};

export default ConstraintEndpointMarker;
